<template lang="pug">
    div.tag-box-control(:invalid='invalid')
        Tags(:settings='tagifySettings' :onChange='onChange' :readonly='disabled' ref='tags')
        div.tag-box-control__dropdown(:hidden='!showDropdown' ref='dropdown')
            custom-scrollbar-control.tag-box-control__dropdown-scroll
                div(ref='dropdownContent')
</template>

<script>
import Tags from '@yaireo/tagify/dist/tagify.vue'

export default {
    name: 'tag-box-control',
    components: { Tags },
    props: {
        value: Array,
        whitelist: Array,
        nameColumn: {
            type: String,
            default: 'name',
        },
        placeholder: String,
        allowCreate: Boolean,
        validateNew: Function,
        disabled: Boolean,
        invalid: Boolean,
    },
    data() {
        return {
            showDropdown: false,
            tagifySettings: {
                whitelist: [],
                editTags: false,
                skipInvalid: true,
                backspace: false,
                duplicates: true,
                placeholder: this.placeholder,
                tagTextProp: this.nameColumn,
                validate: (val) => {
                    const v = val.value
                    if (!v) {
                        return false
                    }
                    if (this.tagify.value.some(i => i.value == v)) {
                        return false
                    }
                    if (this.whitelist.some(i => i.value == v)) {
                        return true
                    }
                    return this.validateNew && this.validateNew(v)
                },
                autoComplete: {
                    enabled: true,
                    rightKey: true,
                },
                dropdown : {
                    enabled: 0,
                    position: 'manual',
                    maxItems: Infinity,
                    closeOnSelect: false,
                    searchKeys: [this.nameColumn],
                },
                templates: {
                    dropdown(settings) {
                        return `
                            <div class="tag-box-control__dropdown-main" role="listbox" aria-labelledby="dropdown">
                                <div class="${settings.classNames.dropdownWrapper}"></div>
                            </div>`
                    },
                    dropdownItem(item) {
                        const exists = this.value.some(i => i.value == item.value)

                        const classList = [
                            this.settings.classNames.dropdownItem,
                            'tag-box-control__dropdown-item',
                        ]

                        if (item.class) {
                            classList.push(item.class)
                        }
                        if (exists) {
                            classList.push('tag-box-control__dropdown-item--exists')
                        }

                        return `
                            <div ${this.getAttributes(item)} class='${classList.join(' ')}' tabindex="0" role="option">
                                <div class="tag-box-control__dropdown-item-check"></div>
                                <span>${item[this.settings.tagTextProp]}</span>
                            </div>`
                    },
                },
                callbacks: {
                    'dropdown:show': () => {
                        this.showDropdown = true
                    },
                    blur: () => {
                        this.showDropdown = false
                    },
                    add: (e) => {
                        const value = e.detail.data.value
                        if (!this.whitelist.some(i => i.value == value)) {
                            this.$emit('create', value)
                        }
                    },
                },
                hooks: {
                    suggestionClick(e, options) {
                        const itemEl = options.suggestionElm
                        const tagify = options.tagify

                        return new Promise((resolve, reject) => {
                            if (itemEl.classList.contains('tag-box-control__dropdown-item--exists')) {
                                tagify.removeTags(itemEl.innerText, false, 5)
                                setTimeout(() => {
                                    tagify.dropdown.refilter.call(tagify)
                                    tagify.DOM.input.focus()
                                }, 10)

                                reject()
                            }
                            else {
                                resolve()
                            }
                        })
                    },
                },
            },
            updating: false,
        }
    },
    computed: {
        model:{
            get(){
                return this.value
            },
            set(val){
                this.$emit('change', val)
            },
        },
        tagify() {
            return this.$refs.tags.tagify
        },
    },
    watch: {
        model(val) {
            this.updateInput(val)
        },
        whitelist(val) {
            this.updateWhitelist(val)
        },
    },
    methods: {
        transformInput(tags) {
            if (tags) {
                return [...tags]
            }
            return []
        },
        updateInput(input) {
            this.updating = true
            this.tagify.removeAllTags()
            this.tagify.addTags(this.transformInput(input))
            this.updating = false
        },
        updateWhitelist(list) {
            this.tagify.settings.whitelist.length = 0
            this.tagify.settings.whitelist.push(...this.transformInput(list))
        },
        updatePlaceholder() {
            this.tagify.settings.placeholder = this.placeholder
        },
        attachManualDropdown() {
            this.$refs.dropdownContent.appendChild(this.tagify.DOM.dropdown)
        },
        onChange(e) {
            if (!this.updating) {
                this.model = this.tagify.value
            }
        },
    },
    mounted() {
        this.updateWhitelist(this.whitelist)
        this.updateInput(this.model)
        this.attachManualDropdown()
    },
}
</script>
